import React, { useContext } from "react"
import { OrderContext } from "../../OrderContext.tsx";
import TextInput from "./TextInput.tsx";

function FormTextInput({ required, label, fieldName, value, error, type, onBlur }: { required?: boolean, label: string, fieldName: string, value: string, error?: string, type?: React.HTMLInputTypeAttribute, onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void }) {
  const { handleFormChange } = useContext(OrderContext);
  return (
    <TextInput type={type ?? "text"} required={required} label={label} fieldName={fieldName} value={value} error={error} onChange={handleFormChange} onBlur={onBlur} />
  )
}

export default FormTextInput;
